import { Component, Inject, Optional } from '@angular/core';
import { SOFTLINE_CONFIG_FORGOT_PASSWORD_LINKS } from '../../password.shared';

import { RouterModule } from '@angular/router';

import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'soft-forgot-password',
    templateUrl: './forgot.component.html',
    styleUrls: ['./forgot.component.css'],
    imports: [RouterModule,
    TranslatePipe]
})
export class ForgotComponent {
  constructor(
    @Optional()
    @Inject(SOFTLINE_CONFIG_FORGOT_PASSWORD_LINKS)
    public links?: { name: string; route: string | string[] }[]
  ) {}
}
